// api.js

import axiosInstance from '../axiosInstance'

export const tmsService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post('/tms-config', data)
      return response.data
    } catch (error) {
      throw error
    }
  },
  fetch: async (id, limit, skip, signal) => {
    try {
      let response = await axiosInstance.get(
        `/tms-config?$limit=${limit || 15}&$skip=${skip || 0}&client_id=${id}&$populate=provider`,
        signal
      )
      return response.data
    } catch (error) {
      throw error
    }
  },
  edit: async (data, id) => {
    try {
      let response = await axiosInstance.patch(`/tms-config/${id}`, data)
      return response.data
    } catch (error) {
      throw error
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/tms-config/${id}`)
      return response.data
    } catch (error) {
      throw error
    }
  }
}
